export const DRAFT_SLUG_KEY = 'DRAFT_SLUG'

export class DraftStorage {
  constructor(storage: Storage = localStorage, key: string = DRAFT_SLUG_KEY) {
    this.storage = storage
    this.key = key
  }

  storage: Storage
  key: string

  clear(): void {
    this.storage.clear()
  }

  getDraftSlug(prefix?: string) {
    return this.storage.getItem(`${prefix}_${this.key}`)
  }

  removeDraftSlug(prefix?: string): void {
    this.storage.removeItem(`${prefix}_${this.key}`)
  }

  setDraftSlug(slug: string, prefix?: string): void {
    this.storage.removeItem(`${prefix}_${this.key}`)
    this.storage.setItem(`${prefix}_${this.key}`, slug)
  }
}

export default new DraftStorage()
